<template>
	<!-- 入库 -->
	<!-- 表格 -->
	<div class="retrieval">
		<div class="title">样本管理 _添加入库</div>
		<a-table
				:scroll="{x:1515}"
				class="hospital-table"
				size="middle"
				:pagination="false"
				:dataSource="data"
				:rowKey="record => record.rowId"
		>
			<a-table-column :width="50" :customRender="(text, record, index) => `${index + 1}`">
				<span class="table-th" slot="title">序号</span>
			</a-table-column>
			<a-table-column :width="130">
				<span class="hospital-required table-th" slot="title">流转机构</span>
				<template slot-scope="text, record,index">
					<div :class="{'has-error':isSubmit&&record.status&&record.deptId==undefined}">
						<a-tree-select
								:getPopupContainer="triggerNode => triggerNode.parentNode"
								style="width: 130px"
								v-model="record.deptId"
								:dropdownStyle="{ maxHeight: '300px', overflow: 'auto' }"
								placeholder='请选择'
								allowClear
								treeDefaultExpandAll>
							<a-tree-select-node v-if="index>0" :key="-1" :value="-1" title="同上">同上</a-tree-select-node>
							<a-tree-select-node v-for="item in treeExpandedKeys" :selectable="false"
							                    :value="item.deptId.toString()"
							                    :title="item.deptName"
							                    :key="item.deptId">
								<a-tree-select-node v-for="cItem in item.children"
								                    :value="cItem.deptId.toString()"
								                    :title="cItem.deptName"
								                    :key="cItem.deptId"/>
							</a-tree-select-node>
						</a-tree-select>
						<!--<a-select :allowClear="true" v-model="record.deptId"-->
						<!--placeholder="请选择流转机构" style="width: 130px">-->
						<!--<a-select-option v-if="index>0" :value="-1">同上</a-select-option>-->
						<!--<a-select-option v-for="item in deptAry" :key="item.key" :value="item.key">-->
						<!--{{item.value}}-->
						<!--</a-select-option>-->
						<!--</a-select>-->
					</div>
				</template>
			</a-table-column>
			<a-table-column :width="130">
				<span class="hospital-required table-th" slot="title">协作组条码</span>
				<template slot-scope="text, record">
					<div :class="{'has-error':isSubmit&&record.status&&!record.hosBarCode}">
						<a-input style="margin: -5px 0;width: 130px" placeholder="请输入协作组条码"
						         v-model="record.hosBarCode"/>
					</div>
				</template>
			</a-table-column>

			<a-table-column :width="130">
				<span class="table-th" slot="title">测序中心条码</span>
				<template slot-scope="text, record">
					<a-input
							style="margin: -5px 0;width: 130px" placeholder="请输入测序中心条码"
							v-model="record.barCode"
					/>
				</template>
			</a-table-column>
			<a-table-column :width="95">
				<span class="table-th" slot="title">检测项目</span>
				<template slot-scope="text, record, index">
					<a-select :getPopupContainer="triggerNode => triggerNode.parentNode" style="width: 100px" v-model="record.applyItemName" placeholder="请选择检测项目">
						<a-select-option v-if="index>0" :value="-1">同上</a-select-option>
						<a-select-option
								:key="item.dictKey"
								:title="item.dictValue"
								v-for="item in applyItems"
								:value="item.dictKey"
						>{{item.dictValue}}
						</a-select-option>
					</a-select>
				</template>
			</a-table-column>
			<a-table-column :width="95">
				<span class="table-th" slot="title">专业组</span>
				<template slot-scope="text, record">
					<a-input
							placeholder="请输入专业组"
							style="margin: -5px 0;width: 95px"
							v-model="record.groupName"
					/>
				</template>
			</a-table-column>

			<a-table-column :width="100">
				<span class="hospital-required table-th" slot="title">样本类型</span>
				<template slot-scope="text, record, index">
					<div :class="{'has-error':isSubmit&&record.status&&!record.sampleTypeName}">
						<a-select :getPopupContainer="triggerNode => triggerNode.parentNode" style="width:100px" v-model="record.sampleTypeName" placeholder="请选择样本类型">
							<a-select-option v-if="index>0" :value="-1">同上</a-select-option>
							<a-select-option
									v-for="item in sampleTypes"
									:key="item.dictKey"
									:value="item.dictKey"
							>{{item.dictValue}}
							</a-select-option>
						</a-select>
					</div>
				</template>
			</a-table-column>
			<a-table-column :width="110">
				<span class="hospital-required table-th" slot="title">样本量（ml）</span>
				<template slot-scope="text, record">
					<div :class="{'has-error':isSubmit&&record.status&&!record.sampleAmount}">
						<a-input
								style="margin: -5px 0;width: 100px"
								type="number"
								placeholder="请输入样本量"
								v-model="record.sampleAmount"
						/>
					</div>
				</template>
			</a-table-column>
			<a-table-column :width="130">
				<span class="hospital-required table-th" slot="title">入库日期</span>
				<template slot-scope="text, record">
					<div :class="{'has-error':isSubmit&&record.status&&!record.createDate}">
						<a-date-picker :getCalendarContainer="triggerNode => triggerNode.parentNode"
						               placeholder="请选择日期"
						               :disabledDate="disabledEndDate"
						               v-model="record.createDate"
						               style="width: 150px"/>
					</div>
				</template>
			</a-table-column>
			<a-table-column :width="170">
				<span class="hospital-required table-th" slot="title">样本编号</span>
				<template slot-scope="text, record">
					<div :class="{'has-error':isSubmit&&record.status&&!record.sampleId}">
						<a-input
								style="margin: -5px 0;width: 170px"
								placeholder="请输入样本编号"
								v-model="record.sampleId"
						/>
					</div>
				</template>
			</a-table-column>
			<a-table-column :width="130">
				<span class="hospital-required table-th" slot="title">存储位置</span>
				<template slot-scope="text, record">
					<div :class="{'has-error':isSubmit&&record.status&&!record.address}">
						<a-input
								style="margin: -5px 0;width: 130px"
								placeholder="一罐一层一格"
								v-model="record.address"
						/>
					</div>
				</template>
			</a-table-column>
		</a-table>
		<div class="confrim-footer">
			<a-button type="primary" @click="addRetrievalSubmit" class="confirm-primary">提交</a-button>
		</div>
	</div>
</template>

<script>
    import moment from 'moment';

    export default {
        data() {
            return {
                dateFormat: 'YYYY-MM-DD h:mm:ss',
                data: [],
                treeExpandedKeys: [],
                sampleTypes: [],
                applyItems: [],
                isSubmit: false,
                isHttpSubmit: false,
                formDatas: [],
            };
        },
        mounted() {
            this.initData();
            this.getDirt("sampleType").then(data => {
                this.sampleTypes = data.rows;
            });
            this.getDirt("applyItem").then(data => {
                this.applyItems = data.rows;
            });
            this.$get("dept/findDeptTreeList").then(
                res => {
                    if (res.data.data) {
                        this.treeExpandedKeys = res.data.data;
                    }
                },
                err => {
                    console.log('err', err);
                }
            );
        },
        methods: {
            moment,
            disabledEndDate(current) {
                return current && current > moment().endOf('day');
            },
            initData() {
                const dataVo = {
                    "rowId": "",
                    "hosBarCode": "",
                    "barCode": "",
                    "sampleId": "",
                    "deptId": undefined,
                    "groupName": "",
                    "applyItemName": undefined,
                    "operateStatus": "1",
                    "address": "",
                    "sampleTypeName": undefined,
                    "sampleAmount": "",
                    "userName": "",
                    "optUserId": "",
                    "createDate": undefined,
                    "delFlag": 0,
                    "status": false,
                };
                for (let i = 0; i < 10; i++) {
                    if (i != 0) {
                        dataVo.sampleTypeName = -1;
                        dataVo.deptId = '-1';
                        dataVo.applyItemName = -1;
                    }
                    dataVo.rowId = i;
                    this.data.push(Object.assign({}, dataVo));
                }
            },
            checkRowData(data) {
                this.formDatas = [];
                this.data.forEach(item => {
                    item.status = false;
                    var status = true;
                    if (
                        item.hosBarCode.trim() != '' ||
                        item.sampleAmount.trim() != '' ||
                        item.createDate != undefined ||
                        item.sampleId.trim() != '' ||
                        item.address.trim() != ''
                    ) {
                        status = false;
                    }
                    if (
                        (item.deptId != -1 && item.deptId != undefined) ||
                        (item.sampleTypeName != -1 && item.sampleTypeName != undefined)
                    ) {
                        status = false;
                    }
                    if (!status) {
                        item.status = true;
                        var formObj = {};
                        for (let keyName in item) {
                            if (keyName != "rowId" && keyName != "status") {
                                formObj[keyName] = item[keyName];
                            }
                        }
                        this.formDatas.push(formObj);
                    }
                });
            },
            addRetrievalSubmit() {
                this.checkRowData();
                this.isSubmit = true;
                if (this.formDatas.length == 0) {
                    this.$message.warning("请输入内容");
                    return;
                }
                this.$nextTick(() => {
                    var errList = document.querySelectorAll(".has-error");
                    if (errList.length == 0) {
                        let _currentItem = {
                            sampleTypeName: "",
                            deptId: "",
                            applyItemName: "",
                        };
                        this.formDatas.forEach(item => {
                            if (item.createDate) {
                                item.createDate = item.createDate.format(this.dateFormat);
                            }
                            // 检查sampleTypeName是否为-1
                            _currentItem.sampleTypeName = item.sampleTypeName != -1 ? item.sampleTypeName : _currentItem.sampleTypeName;
                            item.sampleTypeName = item.sampleTypeName == -1 ? _currentItem.sampleTypeName : item.sampleTypeName;
                            // 检查sexName是否为-1
                            _currentItem.deptId = item.deptId != -1 ? item.deptId : _currentItem.deptId;
                            item.deptId = item.deptId == -1 ? _currentItem.deptId : item.deptId;
                            // 检查applyItemName是否为-1
                            _currentItem.applyItemName = item.applyItemName != -1 ? item.applyItemName : _currentItem.applyItemName;
                            item.applyItemName = item.applyItemName == -1 ? _currentItem.applyItemName : item.applyItemName;
                        });
                        this.isHttpSubmit = true;
                        this.$post("sampleinfo?infoFrom=sample", this.formDatas, {
                            "Content-Type": "application/json"
                        }).then(
                            res => {
                                if (res.data.code == 0) {
                                    this.$message.success(res.data.message);
                                } else {
                                    this.$message.success("样本_添加入库成功!");
                                    this.$emit("close");
                                }
                            },
                            error => {
                                this.isHttpSubmit = false;
                                this.$message.error("样本_添加入库失败!");
                            }
                        );
                    }
                });
            },
            getDirt(dictType) {
                return new Promise((resolve, reject) => {
                    this.$get("info/commonDict", {
                        dictType: dictType
                    }).then(
                        res => {
                            resolve(res.data.data);
                        },
                        err => {
                            reject(err);
                        }
                    );
                });
            },

        }
    };
</script>

<style lang="scss" scoped>
	.retrieval {
		.title {
			padding: 82px 0 56px 0;
			font-size: 26px;
			font-family: PingFang SC;
			font-weight: 400;
			color: rgba(51, 51, 51, 1);
		}
		.confirm-primary {
			width: 100%;
		}
	}

	.table-th {
		color: #a4a4a4;
	}
</style>